import { Body, Heading } from 'components/text';
import { FC } from 'react';
import { MylerResources } from '../contants';
import Container from 'components/container';

const Resources: FC<{}> = () => {
  return (
    <Container className="myler-resources" as="section">
      <div
        className="myler-resources__imageContainer"
        title="myler benefits cover"
      >
        <div className="myler-resources__gradient"></div>
        <div className="myler-resources__heading">
          <Heading as="h4" color="white">
            Unlock access to the best resources in the industry to manage your
            business
          </Heading>
        </div>
      </div>

      <div className="myler-resources__cardList">
        <div className="myler-resources__cardList-wrapper">
          {MylerResources.map((resource, index) => {
            return (
              <div key={index} className="resource-card">
                <div className="resource-card__title">
                  <Heading as="h5" weight="demiBold" color="grey-dark">
                    {resource.name}
                  </Heading>
                </div>
                <div className="resource-card__content">
                  {resource.blocks.map((text, index) => {
                    return (
                      <div key={index}>
                        <Body color="grey-dark">{text} </Body>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Container>
  );
};

export default Resources;
